import React, { createContext, FC, ReactNode, useEffect, useMemo } from 'react'

import { theme as defaultTheme } from '@tribeplatform/design-system/themes/default'
import type { ColorScheme, Theme } from '@tribeplatform/design-system/types'

import { useDocument } from '../hooks/useDocument.js'
import { applyTheme } from './utils.js'

export type ThemeProps = {
  theme: Theme
}

export const ThemeContext = createContext<ThemeProps>({
  theme: defaultTheme,
})

export type ThemeProviderProps = {
  theme?: Theme
  colorScheme?: ColorScheme
  children?: ReactNode
}

export const ThemeProvider: FC<ThemeProviderProps> = ({
  children,
  theme = defaultTheme,
  colorScheme = 'light',
}) => {
  const { document } = useDocument()

  const contextValue = useMemo(
    () => ({
      theme,
    }),
    [theme],
  )

  useEffect(() => {
    const root = document.documentElement
    applyTheme(theme, colorScheme, root)
  }, [document, theme, colorScheme])

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}
